import script from "./RowOfCuttonKhataBokk.vue?vue&type=script&setup=true&lang=js"
export * from "./RowOfCuttonKhataBokk.vue?vue&type=script&setup=true&lang=js"

import "./RowOfCuttonKhataBokk.vue?vue&type=style&index=0&id=4c672b6a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c672b6a"]])

export default __exports__